import { ReactComponent as IconSvg } from './icon_print.svg';
import Icon, { IconProps } from './icon';

const IconPrint = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconPrint;
